<template>
  <el-tooltip v-if="singleLine" :content="content" placement="top">
    <slot></slot>
  </el-tooltip>
  <el-tooltip v-else placement="top">
    <div slot="content" v-html="content"></div>
    <slot></slot>
  </el-tooltip>
</template>

<script>
export default {
  name: 'BjTooltip',
  props: {
    // 提示内容
    content: {
      type: String,
      default: ''
    },
    // 是否是单行显示
    singleLine: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  }
};
</script>

